export default __webpack_public_path__ + "57de687f699e95673c8fee487bd1f75d.png";